<template>
    <div>
        <div class="track-header">
            <div class="container">
                <div class="d-flex justify-center flex">
                    <div class="input-bar d-flex align-center flex">
                        <input type="text" v-model="enteredTrackingNumber" class="flex h-100 search-input" placeholder="Enter tracking number">
                        <v-btn @click="trackShipment(enteredTrackingNumber)"
                        class="color-red mr-1 px-10 font-weight-bold"
                        x-large
                        rounded
                        dark
                        >
                        Track
                        <v-icon right>
                            mdi-play-circle
                        </v-icon>

                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
        <div class="tracking-info" v-if="Object.keys(trackedShipment).length === 0"> 
            <div class="mt-10 text-center gotham-medium">
               
                <div class="mt-3 font-weight-bold text-h6 px-10 px-md-0">
                    Your tracking information will appear here...
                </div>
            </div>
        </div>
        <div v-else> 
            <div class="mt-10 text-center gotham-medium">
                <div class="font-weight-bold">
                    {{trackedShipment.tracker.trackingNumber}}
                </div>
                <div class="mt-3 font-weight-bold text-h6 px-10 px-md-0">
                    Your package has been in transit for 5 days
                </div>
            </div>
            <div class="d-block d-md-flex justify-between container mt-10">
                <div class="flex order-tracking mb-10" >
                    <div class="d-flex gotham-medium " v-for="event in trackedShipment.events" :key="event.eventId">
                        <div class="mr-2 mr-md-10 w-30 border-right-gray" :class="{'border-right-primary': event.statusCode}">
                            <div class="dates mr-md-10">
                                <div>{{ event.datetime | formatDate }}</div>
                                <div>{{ event.datetime | formatTime }}</div>
                            </div>
                        </div>
                        <div class="w-75">
                        <div class="mb-4">
                            <div class="font-weight-bold text-h6">
                                {{ event.status }}
                            </div>
                         <div class="mt-2 gotham-light"> 
                                There is no further information available from carrier <br>
                            </div> 
                        </div>
                        </div>
                    </div>
                    <!-- <div class="d-flex gotham-medium mt-8">
                        <div class="mr-10">
                            <div class="dates mr-10">
                                <div>Feb 8, 2022 <br> 14:32</div>
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold text-h6">
                                At the customer local depot
                            </div>
                            <div class="mt-2 gotham-light">
                                At the customer local depot.<br>At the national sorting hub.
                            </div>
                            <v-btn color="red" dark plain depressed>Exception</v-btn>
                        </div>
                    </div> -->
                    <!-- <div class="d-flex gotham-medium mt-8">
                        <div class="mr-10">
                            <div class="dates mr-10">
                                <div>Feb 8, 2022 <br> 14:32</div>
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold text-h6">
                                Entered the Evri Network
                            </div>
                            <div class="mt-2 gotham-light">
                                Your package is in transit with the carrier<br>Collected at the ParcelShop
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="d-flex gotham-medium mt-8">
                        <div class="mr-10">
                            <div class="dates mr-10">
                                <div>Feb 8, 2022 <br> 14:32</div>
                            </div>
                        </div>
                        <div>
                            <div class="font-weight-bold text-h6">
                                Order placed
                            </div>
                            <div class="mt-2 gotham-light">
                                The carrier has been informed and will soon collect your <br>package
                            </div>
                            <div>
                                <v-btn outlined color="appGreen">
                                    <v-icon left>
                                        mdi-content-paste
                                    </v-icon>
                                    Order Placed
                                </v-btn>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="flex d-flex justify-end">
                    <div class="flex">
                        <div class="summary-block white--text gotham-medium">
                            <div class="font-weight-bold text-h6">Summary</div>
                            <div class="mt-8 font-weight-bold text-subtitle-2">Tracking Number</div>
                            <div class="mt-1">{{ trackedShipment.tracker.trackingNumber }}</div>
                            <div class="mt-8 font-weight-bold text-subtitle-2">Courier</div>
                            <div class="mt-1">{{ trackedShipment.events[0].courierCode }}</div>
                            <div class="mt-8 font-weight-bold text-subtitle-2">Days in Transit</div>
                            <div class="mt-1">5</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <home-footer class="d-none d-md-block" />
    </div>
</template>
<script>
import HomeFooter from "@/components/Shared/HomeFooter/HomeFooter.vue";
import moment from 'moment';
export default {
    components: {
        HomeFooter
    },
    filters: {
        formatDate(date) {
            let momentDate = moment(date);
            momentDate.format('MMM')
            return momentDate.format('MMM d[, ]YYYY')
        },
        formatTime(date) {
            let momentDate = moment(date);
            momentDate.format('MMM')
            return momentDate.format('H:mm')
        }
    },
    data: () => ({
        enteredTrackingNumber: ''

    }),
    mounted() {

       let trackingNumber = this.$route.query.tracking_number;

       if (trackingNumber) {
         this.trackShipment(trackingNumber);
       }
    },
    computed: {

        trackedShipment() {
            return this.$store.state.order.trackedShipment;
        }

    },
    methods: {
        trackShipment(trackingNumber) {
            console.log(trackingNumber)
          this.$store.dispatch("order/TRACK_SHIPMENT", trackingNumber);
        }
    }

}
</script>
<style scoped>
.track-header {
    background-color: #00536D;
    height: 7.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}
.input-bar {
    border-radius: 2.2rem;
    height: 3.7rem;
    background: #fff;
}
.input-bar .track-button {
    border-radius: 2.2rem;
    background: #FF2424;

}
.color-red {
    background: #FF2424 !important;
}
.summary-block {
    padding: 1.5rem;
    background: #23A0A0;
    width: 20rem;
    border-radius: 10px;
}
@media screen and (max-width: 640px) {
    .summary-block {
        width: 100%;
    }
}
.dates {
    color: #667085;
}
.border-right {
    border-right: 1px solid #23A0A0;
}
.progress {
    height: 100%;
    width: 2px;
    background: #E4E7EC;
}
.order-tracking {
    position: relative;
}
.progress {
    height: 100%;
    width: 2px;
    background: #E4E7EC;
    position: absolute;
    left: 140px;
}
.completed-progress {
    position: absolute;
    width: 2px;
    background: #23A0A0;
    top: 0;
}
input.search-input {
    height: 100%;
    padding: 30px;
}
@media screen and (max-width: 640px) { 
   input.search-input {
    height: 100%;
    padding: 0 0 0 15px;
} 
}
input.search-input:focus {
    outline: none;
}
.w-30 {
    width: 20%;
}
.w-75 {
    width: 80%;
}
@media screen and (max-width: 640px) { 
  .w-30 {
    width: 30%;
}
.w-75 {
    width: 70%;
}  
}
.border-right-primary{
    border-right: 2px solid #23A0A0;
}
.border-right-gray{
    border-right: 2px solid #E4E7EC;
}
</style>